import { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

import './index.css'

export default function InstagramCarousel({ posts = [], width = 500, height = 300}) {
  const [index, setIndex] = useState(0);
  const [sense, setSense] = useState(0);

  const prev = () => {
    setIndex((index - 1 + posts.length) % posts.length);
    setSense(-1);
  };

  const next = () => {
    setIndex((index + 1) % posts.length);
    setSense(1);
  };

  const touchStartRef = useRef(0);
  const touchEndRef = useRef(0);

  const touchstart = (e) => {
    touchStartRef.current = e.touches[0].clientX;
    touchEndRef.current = e.touches[0].clientX;
  };

  const touchmove = (e) => {
    touchEndRef.current = e.touches[0].clientX;
  };

  const touchend = () => {
    const diff = touchStartRef.current - touchEndRef.current;
    if (diff > 50) {
      next();
    }
    else if (diff < -50) {
      prev();
    }
  }

  return (
    <div
      className="carousel-container"
      style={{height: `${height}px`, width: `${width}px`}}
      onTouchStart={touchstart}
      onTouchMove={touchmove}
      onTouchEnd={touchend}
    >
      <AnimatePresence mode="wait">
        <motion.a
          key={index}
          href={posts[index].link}
          target="_blank"
          rel="noopener noreferrer"
          className="carousel-item"
          initial={{ opacity: 0, x: 80*sense }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 40*(-sense) }}
          transition={{ duration: 0.4 }}
        >
          <img
            src={posts[index].image}
            alt="Instagram post"
            className="carousel-image"
            style={{height: `${height}px`, width: `${width}px`}}
          />
        </motion.a>
      </AnimatePresence>

      <img className="carousel-btn left" src='../../images/left-arrow.png' title='anterior' onClick={prev}></img>
      <img className="carousel-btn right" src='../../images/right-arrow.png' title='siguiente' onClick={next}></img>

    </div>
  );
}
